<template>
  <v-jumbotron>
    <v-container fill-height>
      <v-layout align-center>
        <v-flex>
          <h4 class="display-2 my-3">
            Preparing your solution
          </h4>

          <span class="subheading">
            <p>Check the <v-btn flat color="primary" to="tutorial" class="mx-0 my-0">Tutorial</v-btn> to learn how to prepare your submission for evaluation. The tutorial explains the submission format requirements, the containerization process, and how to validate/debug your container locally.</p>

            <p>For each submission, your containerized code is used to perform inference over the images in the validation dataset, producing a set of bounding box predictions for each input image. Then a mean average precision (mAP) score is computed across all the bounding box predictions. Submissions are ranked by mAP.</p>

          </span>
          <v-divider></v-divider>
          <!-- <div class="title my-4">?</div> -->
          <v-btn color="primary" dark class="mx-0 my-4" to="tour4">Next</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-jumbotron>

</template>

<script>
  export default {
    name: 'Tour3',
    data () {
      return {
        // foo: 'bar'
        // gradient: '315deg, #3f87a6, #f69d3c',
      }
    },
    mounted () {
      // console.log('Tour3 component mounted')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Tour/Tour3.vue